"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const foundations_1 = require("@airstudio/foundations");
const querystring = require("querystring");
const actions = require("./actions");
exports.fetch = (dispatch) => {
    return async (workspaceId, objectType, searchQuery = {}) => {
        dispatch(actions.fetchRequest(objectType));
        if (!searchQuery.query) {
            delete searchQuery.query;
        }
        if (!searchQuery.page) {
            delete searchQuery.page;
        }
        if (!searchQuery.size) {
            delete searchQuery.size;
        }
        if (!searchQuery.sort) {
            delete searchQuery.sort;
        }
        try {
            const { data } = await foundations_1.Api.client.get(`${objectType}?${querystring.stringify(searchQuery)}`);
            // Extract the data from the response
            // /orders => orders: { ... }
            // /orders/0000/items => items: { ... }
            const arrayKey = foundations_1._.last(objectType.split('/'));
            if (!data[arrayKey]) {
                console.warn(`API response does not have a "${arrayKey}" root object`);
            }
            dispatch(actions.fetchSuccess(objectType, workspaceId, data[arrayKey]));
        }
        catch (error) {
            dispatch(actions.fetchFailure(objectType, foundations_1.Api.extractErrorMessage(error)));
            return false;
        }
        return true;
    };
};
exports.fetchOne = (dispatch) => {
    return async (workspaceId, objectType, objectId) => {
        dispatch(actions.fetchOneRequest(objectType, objectId));
        try {
            const { data } = await foundations_1.Api.client.get(`${objectType}/${objectId}`);
            const arrayKey = Object.keys(data)[0];
            if (!data[arrayKey]) {
                // tslint:disable-next-line: no-console
                console.warn(`API response does not have a "${arrayKey}" root object`);
            }
            dispatch(actions.fetchOneSuccess(objectType, objectId, workspaceId, data[arrayKey]));
        }
        catch (error) {
            dispatch(actions.fetchOneFailure(objectType, objectId, foundations_1.Api.extractErrorMessage(error)));
            return false;
        }
        return true;
    };
};
exports.save = (dispatch) => {
    return async (workspaceId, objectType, item, itemId, newIdCallback) => {
        dispatch(actions.saveRequest(objectType, itemId || '_'));
        try {
            if (itemId) {
                const { data } = await foundations_1.Api.client.put(`${objectType}/${itemId}`, { item });
                const arrayKey = foundations_1._.last(Object.keys(data));
                if (!data[arrayKey]) {
                    // tslint:disable-next-line: no-console
                    console.warn(`API response does not have a "${arrayKey}" root object`);
                }
                dispatch(actions.saveSuccess(objectType, itemId, workspaceId, data[arrayKey]));
            }
            else {
                const { data } = await foundations_1.Api.client.post(`${objectType}`, { item });
                const arrayKey = foundations_1._.last(Object.keys(data));
                if (!data[arrayKey]) {
                    // tslint:disable-next-line: no-console
                    console.warn(`API response does not have a "${arrayKey}" root object`);
                }
                dispatch(actions.saveSuccess(objectType, '_', workspaceId, data[arrayKey]));
                // tslint:disable-next-line: no-unused-expression
                newIdCallback && newIdCallback(data[arrayKey].id);
            }
        }
        catch (error) {
            dispatch(actions.saveFailure(objectType, itemId || '_', foundations_1.Api.extractErrorMessage(error)));
            return false;
        }
        return true;
    };
};
exports.custom = (dispatch) => {
    return async ({ workspaceId, request, statePath, reducers }) => {
        dispatch(actions.customRequest(statePath));
        try {
            const { data } = await foundations_1.Api.client.request(request);
            dispatch(actions.customSuccess(statePath, workspaceId, data, reducers));
            return data;
        }
        catch (error) {
            dispatch(actions.customFailure(statePath, foundations_1.Api.extractErrorMessage(error)));
            return null;
        }
    };
};
//# sourceMappingURL=operations.js.map